import { ColDef } from '@ag-grid-enterprise/all-modules'
import i18n from '@/lang/i18n'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { ConfigurationPossibleAssayResultResponse } from '@/modules/configurationModule/detail/local-assays/results/services/configuration-possible-assay-result/configuration-possible-assay-result.dto'
import { configurationPossibleAssayResultService } from '@/modules/configurationModule/detail/local-assays/results/services/configuration-possible-assay-result/configuration-possible-assay-result.service'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { store } from '@/store/store'

export const columnsDefLocalAssayResultGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.assayResult'),
            field: 'name',
            minWidth: 400,
            flex: 1,
            suppressSizeToFit: true,
            sortable: false
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.code'),
            field: 'code',
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true,
            sortable: false
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            minWidth: 80,
            suppressSizeToFit: true
        }
    ]

export interface ConfigurationLocalAssaysResultsGridState extends CrudModelPaginatorLaboratory<ConfigurationPossibleAssayResultResponse> {
    service: typeof configurationPossibleAssayResultService,
    laboratoryId: number
}
export const initialConfigurationLocalAssaysResultsGridState =
    (): ConfigurationLocalAssaysResultsGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.assays.assaysResults',
        columnsDef: columnsDefLocalAssayResultGrid(),
        datasource: new PaginatorLaboratoryDatasource(configurationPossibleAssayResultService, store.getters.labId),
        service: configurationPossibleAssayResultService,
        laboratoryId: store.getters.labId
    })
